import type { CategoryKeywordItem } from "@/types";
import { cfFetch } from "../../api/apiClient";

function parseDetail(body: unknown): string {
  const b = body as { detail?: { error?: string } | string };
  const d = b.detail;
  return typeof d === "string"
    ? d
    : typeof d === "object" && d?.error
      ? d.error
      : "Request failed";
}

export async function fetchCategoryKeywords(
  categoryId: string,
): Promise<CategoryKeywordItem[]> {
  const res = await cfFetch(`/categories/${categoryId}/keywords`);
  if (!res.ok) throw new Error(parseDetail(await res.json().catch(() => ({}))));
  return res.json();
}

export async function createCategoryKeyword(
  categoryId: string,
  keyword: string,
  confidence = 0.8,
): Promise<CategoryKeywordItem> {
  const res = await cfFetch(`/categories/${categoryId}/keywords`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ keyword: keyword.trim(), confidence }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(parseDetail(body));
  const row = body as Record<string, unknown>;
  const {
    id,
    userId,
    categoryId: cid,
    keyword: kw,
    normalizedKeyword,
    confidence: conf,
    createdAt,
    updatedAt,
  } = row;
  return {
    id: String(id),
    userId: userId === undefined || userId === null ? null : String(userId),
    categoryId: String(cid),
    keyword: String(kw),
    normalizedKeyword: String(normalizedKeyword),
    confidence: Number(conf),
    createdAt: String(createdAt),
    updatedAt: String(updatedAt),
  };
}

export async function deleteCategoryKeyword(
  categoryId: string,
  keywordId: string,
): Promise<void> {
  const res = await cfFetch(`/categories/${categoryId}/keywords/${keywordId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(parseDetail(await res.json().catch(() => ({}))));
}
